import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { GzSelectedListItemWebComponent } from '../../gzSelectedListItem';
import { isEmpty } from 'lodash';
import { EventTypes } from '../../gzSelectedListItem/types';
import { SelectedListItem } from '../../gzSelectedListItemGenerator/types';

@customElement('gz-selected-list')
export class GzSelectedListWebComponent extends LitElement {
  /**
   * @property
   * Property to store the selected options
   */
  @property({ type: Array, attribute: true, reflect: true })
  selectedItems: SelectedListItem[] = [];

  /**
   * @property
   * Property to store the items to be added to the list
   */
  @state()
  displayedListItems: GzSelectedListItemWebComponent[] = [];

  /**
   * @property
   * Property to store the text translations
   */
  @property({ type: String, attribute: true, reflect: true })
  emptyStateText = 'No items selected[***]';

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    this.displayedListItems = [];
    for (const item of this.selectedItems) {
      const newItem = new GzSelectedListItemWebComponent();
      newItem.item = item;
      newItem.addEventListener(EventTypes.DELETE_ITEM, () => {
        this.handleDeleteItemList(newItem);
      });
      this.displayedListItems.push(newItem);
    }

    return html`${isEmpty(this.displayedListItems) ? this.renderEmptyState() : this.displayedListItems}`;
  }

  private renderEmptyState(): TemplateResult | undefined {
    if (isEmpty(this.emptyStateText)) {
      return;
    }

    return html`<gz-text class="empty" fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}"
      >${this.emptyStateText}</gz-text
    >`;
  }

  private handleDeleteItemList(itemComponent: GzSelectedListItemWebComponent): void {
    const index = this.displayedListItems.indexOf(itemComponent);
    this.selectedItems = this.selectedItems.filter((item, i) => i !== index);
    this.dispatchEvent(new CustomEvent(EventTypes.DELETE_ITEM, { detail: itemComponent.item }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-selected-list': GzSelectedListWebComponent;
  }
}
